export default {
  name: 'oIcon',
  props: {
    type: {
      type: String
    }
  }
};
